import Wrapper from '../../../assets/wrappers/ProcessingFile'
import TopHeader from '../../../components/TopHeader'
import SabhaSaarHeader from '../../../components/SabhaSaarHeader'
import { useSelector, useDispatch } from 'react-redux'
import { fetchMeetingTypes, languages, openDedupErrorModal, setDedupErrorMessage, setDedupErrorModalType, setResult } from '../../../features/upload/uploadSlice'
import React, { useEffect, useState } from 'react'
import Flatpickr from 'react-flatpickr';
import "flatpickr/dist/themes/material_green.css";
import FinalResult from './FinalResult'
import Footer from '../../../components/Footer'
import UserInfo from '../../../components/UserInfo'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { RootState } from '../../../store'
import protectedAPI from '../../../services/axiosInstance'
import { stopGlobalAudio } from '../../../utils/audioManager'
import { useLocation } from "react-router-dom";
import { logout } from '../../../features/authSlice'
const { IoArrowBack } = require("react-icons/io5");

const FaVideo = require('react-icons/fa').FaVideo;
const FaMusic = require('react-icons/fa').FaMusic;
const FaCalendarAlt = require('react-icons/fa').FaCalendarAlt;

const ProcessingFile: React.FC = () => {
    const { portal, meetingDetailsNirnany } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { meetingTypes, isDirty, loading, error } = useSelector(
        (state: RootState) => state.upload
    );
    const result = useSelector((state: any) => state.upload.result);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const file = useSelector((state: any) => state.upload.file);
    const [progress, setProgress] = useState(0);
    const [isCompleted, setIsCompleted] = useState(false);
    const [currentStage, setCurrentStage] = useState('');
    const task_id = useSelector((state: any) => state.upload.apiInfo?.task_id);
    const meetingAttendees = useSelector((state: any) => state.upload.meetingAttendees);
    const location = useLocation();
    const progressMessages = [
        "Your file is being processed securely…",
        "Analyzing content, please wait…",
        "This may take a few moments, do not close this window.",
        "Processing in progress, almost there…",
        "Finalizing results, preparing your output…",
    ];

    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        if (!isCompleted) {
            const interval = setInterval(() => {
                setMessageIndex((prev) => (prev + 1) % progressMessages.length);
            }, 10000);

            return () => clearInterval(interval);
        }
    }, [isCompleted]);

    useEffect(() => {
        if (meetingTypes.length) {

            dispatch(fetchMeetingTypes() as any);
        }
    }, [dispatch]);

    useEffect(() => {
        if (!task_id) {
            toast.error("Something went wrong. Please upload your file again.");
            if (portal === "N") {
                dispatch(logout());
                navigate("/");
            } else {
                navigate('/upload');
            }
        }
    }, [task_id, navigate]);

    useEffect(() => {
        if (file?.file) {
            const objectUrl = URL.createObjectURL(file.file);
            setPreviewUrl(objectUrl);
            return () => {
                URL.revokeObjectURL(objectUrl);
            };
        } else {
            setPreviewUrl(null);
        }
    }, [file]);


    useEffect(() => {
        if (!task_id) return;

        const interval = setInterval(async () => {
            try {
                const response = await protectedAPI.get(
                    `${baseUrl}api/status/${task_id}`
                );

                const data = response.data;

                if (data?.msg_code === 200) {
                    if (data.status === "AWAITING RESPONSE" && data.dedup_status === "REJECTED") {
                        clearInterval(interval);
                        dispatch(setDedupErrorMessage(data.duplicate_message || "This file has already been uploaded."));
                        dispatch(setDedupErrorModalType("DUPLICATE"));
                        navigate("/upload");
                        return;
                    }
                    if (data.status === "FAILED" && (data.dedup_status === "NO_SPEECH" || data.dedup_status === "INVALID_MEDIA")) {
                        clearInterval(interval);
                        dispatch(setDedupErrorMessage("Uploaded media is not processable. The audio track may be missing, corrupted, or unreadable. Please upload a valid audio/video file."));
                        dispatch(setDedupErrorModalType("PROCESSING_FAILED"));
                        navigate("/upload");
                        return;
                    }
                    setProgress(data.progress);
                    setCurrentStage(data.status);

                    if (data.progress >= 100 || data.status === "COMPLETED") {
                        clearInterval(interval);
                        fetchResult();
                    }
                } else if (data?.msg_code === 500) {
                    throw new Error(data.msg || "Internal Server Error");
                }
            } catch (error) {
                console.error("Error fetching status:", error);
                toast.error("Processing failed. Please try again.");
                navigate("/upload");
            }
        }, 10000);

        return () => clearInterval(interval);
    }, [task_id]);

    const fetchResult = async () => {
        try {
            const response = await protectedAPI.get(
                `${baseUrl}api/result/${task_id}`
            );

            const data = response.data;

            if (data?.msg_code === 200) {
                dispatch(
                    setResult({
                        original_transcript: data.original_transcript,
                        translated_transcript_en: data.translated_transcript_en,
                        summary_en: data.summary_en,
                        transcription_readiness_score: data.transcription_readiness_score
                    })
                );
                setIsCompleted(true);
            } else {
                throw new Error(data?.msg || "Error fetching result");
            }
        } catch (error) {
            console.error("Error fetching result:", error);
            toast.error("Could not fetch result. Please try again.");
            navigate("/upload");
        }
    };


    const handleBackNavigation = () => {
        const currentPath = location.pathname;
        const shouldShowConfirm = (currentPath === "/processing" || currentPath.startsWith("/draft-meeting/")) && !isDirty;
        if (shouldShowConfirm) {
            const confirmed = window.confirm(
                "You have unsubmitted changes in your SabhaSaar MoM data. Are you sure you want to leave?"
            );

            if (!confirmed) return;
        }
        navigate("/upload");
        stopGlobalAudio();
    };
    return (
        <Wrapper>
            <TopHeader />
            <section className="body-content ">
                <SabhaSaarHeader />
                <div className="container">
                    <UserInfo />
                    <div className="row mt-5 align-items-stretch" id="processingSkipMain">
                        <div className="col-md-12">
                            <div className="card h-100">
                                <div className="card-body media-player-container">


                                    <div className="d-flex justify-content-end">
                                        {portal !== "N" && <div className="goBack" onClick={handleBackNavigation}>
                                            <IoArrowBack size={24} /> Back
                                        </div>
                                        }
                                    </div>
                                    <form action="">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label className=" form-label my-2 mandatory">Meeting Date </label>
                                                    <div className="input-group">
                                                        <div className="input-group full-width-group">
                                                            <span className="input-group-text">
                                                                <FaCalendarAlt />
                                                            </span>
                                                            <Flatpickr
                                                                value={file?.date ? new Date(file.date) : new Date()}
                                                                options={{
                                                                    dateFormat: 'd/m/Y',
                                                                    //maxDate: new Date(),
                                                                }}
                                                                disabled
                                                                className="form-control cus-date disabled"
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label className="form-label my-2 mandatory">Meeting Type</label>
                                                    {
                                                        portal !== "N" ? <div className="input-group">
                                                            <select
                                                                name="meetingType"
                                                                className="form-select not-allowed"
                                                                value={file?.meetingType}
                                                                disabled={true}
                                                            >
                                                                <option value="">Select Meeting Type</option>
                                                                {meetingTypes?.map((parent) => (
                                                                    <optgroup key={parent.id} label={parent.name}>
                                                                        {parent.sub_options.map((sub) => (
                                                                            <option key={sub.id} value={sub.id}>
                                                                                {sub.name}
                                                                            </option>
                                                                        ))}
                                                                    </optgroup>
                                                                ))}
                                                            </select>
                                                        </div> : <input type="text" name="" id="" className='form-control' value={meetingDetailsNirnany.meeting_type_name} disabled={true} />
                                                    }
                                                </div>
                                            </div>


                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label className=" form-label my-2 mandatory">Select Source Language</label>
                                                    <div className="input-group">
                                                        <select
                                                            name="sourceLanguage"
                                                            className="form-select  not-allowed"
                                                            value={file?.language}
                                                            disabled={true}
                                                        >
                                                            <option value="">Select Source Language</option>
                                                            {languages.map(lang => (
                                                                <option key={lang.code} value={lang.code}>
                                                                    {lang.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div className="row mt-2">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className=" form-label my-2 mandatory">Add Meeting Title</label>
                                                    <div className="input-group">
                                                        <textarea className="form-control not-allowed" name="meetingTitle" disabled={true} value={file?.meetingTitle} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {meetingAttendees && (
                                            <div className="attendees-summary-box p-3 border-dashed mt-2">
                                                <h5 className="text-center mandatory mb-3">Add Attendees Details</h5>

                                                <div className="row g-3 not-allowed">
                                                    <div className="col-12 d-flex flex-column flex-md-row">
                                                        {/* Gender Wise Box */}
                                                        <div className="flex-fill p-3 bg-light me-md-2 d-flex flex-column">
                                                            <h6 className="text-center">No. of Attendees Gender wise</h6>
                                                            <div className="gender-data-p mt-2">
                                                                <p>Male : <b>{meetingAttendees?.by_gender?.Male}</b></p>
                                                                <p>Female : <b>{meetingAttendees?.by_gender?.Female}</b></p>
                                                                <p>Others : <b>{meetingAttendees?.by_gender?.Others}</b></p>
                                                                <p>Total : <b>{meetingAttendees?.total_attendees}</b></p>
                                                            </div>
                                                        </div>

                                                        {/* Caste Wise Box */}
                                                        <div className="flex-fill p-3 bg-success-subtle ms-md-2 d-flex flex-column">
                                                            <h6 className="text-center">No. of Attendees Caste wise</h6>
                                                            <div className="cast-data-p mt-2">
                                                                <p>General : <b>{meetingAttendees?.by_social_category?.General}</b></p>
                                                                <p>OBC : <b>{meetingAttendees?.by_social_category?.OBC}</b></p>
                                                                <p>SC : <b>{meetingAttendees?.by_social_category?.SC}</b></p>
                                                                <p>ST : <b>{meetingAttendees?.by_social_category?.ST}</b></p>
                                                                <p>Others : <b>{meetingAttendees?.by_social_category?.Others}</b></p>
                                                                <p>Total : <b>{meetingAttendees?.total_attendees}</b></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        )}

                                    </form>
                                    <div className="">
                                        {file && (
                                            <>
                                                <div className="media-details">
                                                    {file.fileType.startsWith('video') ? (
                                                        <><FaVideo /></>
                                                    ) : (
                                                        <> <FaMusic /></>
                                                    )}
                                                    <p className='file-name'> {file.fileName}</p>
                                                    <p className='grey-text-file'> {(file.fileSize / 1024 / 1024).toFixed(2)} MB</p>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    {file && (
                                        <div className="preview-player mt-3">
                                            {file.fileType.startsWith('video') ? (
                                                <video controls src={previewUrl || ""}>
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : (
                                                <audio controls src={previewUrl || ""}>
                                                    Your browser does not support the audio tag.
                                                </audio>
                                            )}
                                        </div>
                                    )}
                                    {result?.transcription_readiness_score && (
                                        <p className="alert alert-warning text-center fw-semibold mt-3">
                                            Your Audio Quality Score is {" "}
                                            <span className="badge bg-primary ms-2">
                                                {result.transcription_readiness_score}%
                                            </span>
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                {!isCompleted && (
                    <div className="custom-progress-overlay">
                        <div className="custom-progress-content">
                            <p className='processing-status'>Processing Status</p>
                            <div className="modern-spinner"></div>
                            <p className="processing-text">{currentStage || 'Initializing...'}</p>
                            <div className="custom-progress-bar-container">
                                <div
                                    className="custom-progress-bar"
                                    style={{ width: `${progress}%` }}
                                >
                                    {progress}%
                                </div>
                            </div>

                            <p className="progress-message mt-3">
                                {progress < 100 - 10 ? progressMessages[messageIndex] : "Almost done…"}
                            </p>
                        </div>
                    </div>
                )}
                {isCompleted && (
                    <div className="container mt-3">
                        <FinalResult />
                    </div>
                )}

            </section>
            <Footer />
        </Wrapper>

    )
}

export default ProcessingFile